import { AppConstants } from '../../../constants/AppConstants';

interface StatusTagProps {
  status: string;
}

const statusColor: any = {
  [AppConstants.MIGRATION_STATUS_COMPLETED]: {
    borderColor: '#91BFDB',
    background: '#E1ECF4'
  },
  [AppConstants.MIGRATION_STATUS_SUCCESS]: {
    borderColor: '#86CF9B',
    background: '#dbf0e1'
  },
  [AppConstants.MIGRATION_STATUS_FAILED]: {
    borderColor: '#D73027',
    background: '#EFCFD0'
  },
  default: {
    borderColor: '#91BFDB',
    background: '#E1ECF4'
  }
};

const StatusTag = ({ status }: StatusTagProps) => {
  return (
    <div
      className="w-[7.5rem] rounded-sm border border-solid px-2 py-[0.063rem] text-center text-sm font-light"
      style={statusColor[status] || statusColor.default || AppConstants}
    >
      {status}
    </div>
  );
};

export default StatusTag;
